import React, { useState, useEffect } from 'react';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import CheckIcon from '@mui/icons-material/Check';
import localization from '../locals/en.json'

interface CopyButtonProps {
    textToCopy: string;
    disabled?: boolean; // New disabled prop
}

const CopyButton: React.FC<CopyButtonProps> = ({ textToCopy, disabled = false }) => {
    const [copied, setCopied] = useState(false);

    const handleCopy = async () => {
        if (disabled) return; // Prevent copy action if disabled
        try {
            await navigator.clipboard.writeText(textToCopy);
            setCopied(true);
        } catch (err) {
            console.error('Failed to copy:', err);
        }
    };

    useEffect(() => {
        if (copied) {
            const timer = setTimeout(() => setCopied(false), 2000);
            return () => clearTimeout(timer);
        }
    }, [copied]);

    return (
        <Tooltip
            title={copied ? "" : localization.tooltips.chat.copy}
        >
            <IconButton
                onClick={handleCopy}
                disabled={disabled} // Apply disabled prop
                sx={{
                    transition: 'opacity 0.3s ease-in-out',
                    opacity: copied ? 1 : (disabled ? 0.5 : 0.7), // Adjust opacity for disabled state
                    '&:hover': {
                        opacity: disabled ? 0.5 : 1, // Maintain disabled opacity on hover
                    },
                }}
            >
                {copied ? <CheckIcon /> : <ContentCopyIcon />}
            </IconButton>
        </Tooltip>
    );
};

export default CopyButton;